import { createWebHistory, createRouter } from 'vue-router'

/* Layouts */
import App from '@layouts/App.vue'

/* Pages */
import Index from '@pages/Index.vue'
import Work from '@pages/Work.vue'
import Project from '@pages/Project.vue'
import Services from '@pages/Services.vue'
import About from '@pages/About.vue'
import News from '@pages/News.vue'
import Article from '@pages/Article.vue'
import Contact from '@pages/Contact.vue'
import Playground from '@pages/Playground.vue'
import LostArt from '@pages/LostArt.vue'
import PolicyPage from '@pages/PolicyPage.vue'

import Debug from '@pages/Debug.vue'
import Castle from '@pages/Castle.vue'

/* Routes */
const routes = [
	{
		path: '/',
		component: App,
		children: [
			{ path: '', name: 'index', component: Index },
			{ path: 'work', name: 'work', component: Work },
			{ path: 'project/:slug', name: 'project', component: Project },
			{ path: 'services', name: 'services', component: Services },
			{ path: 'about', name: 'about', component: About },
			{ path: 'news', name: 'news', component: News },
			{ path: 'article/:slug', name: 'article', component: Article },
			{ path: 'contact', name: 'contact', component: Contact },
			{ path: 'playground', name: 'playground', component: Playground },
			{ path: 'lost-art', name: 'lost-art', component: LostArt },
			{ path: 'debug', name: 'debug', component: Debug },
			{ path: 'castle', name: 'castle', component: Castle },
			{ path: 'policy/:slug', name: 'policy', component: PolicyPage },
			{ path: '/:catchAll(.*)', name: '404', redirect: { name: 'index' } },
		],
	},
]

const router = createRouter({
	scrollBehavior(to, from, savedPosition) {
		if (to.name == from.name && !to.hash) {
			return { top: 0, behavior: 'smooth' }
			// } else if (to.name == 'services' && to.hash) {
			// 	return new Promise((resolve, reject) => {
			// 		setTimeout(() => {
			// 			resolve({
			// 				el: '#services',
			// 				top: 50,
			// 				behavior: 'smooth',
			// 			})
			// 		}, 400)
			// 	})
		} else if (to.hash) {
			return {
				el: to.hash,
				top: 100,
				behavior: 'smooth',
			}
		} else {
			// Delay returning to top until fade transition ends
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					resolve({ top: 0 })
				}, 500)
			})
		}
	},
	history: createWebHistory(),
	routes,
})

export default router
